import './style.scss';

export interface IRadioButtonProps {
    name: string;
    options: string[];
    labels: string[];
    onSelect?: (evt: any) => void;
    selectedOption: string;
    disabled?: boolean;
}
export interface IRadioButtonOptionProps {
    parentName: string;
    option: string;
    label: string;
    onSelect: any;
    selected: boolean;
    disabled?: boolean;
}

export const RadioButtonOption: React.FC<IRadioButtonOptionProps> = ({
    parentName,
    option,
    label,
    onSelect,
    selected,
    disabled = false,
}) => {
    return (
        <label className='radio-option'>
            <input
                className='radio-input'
                type='radio'
                name={parentName}
                value={option}
                onChange={() => onSelect(option)}
                checked={selected}
                disabled={disabled}
            />
            <span className='radio-label'>{label}</span>
        </label>
    );
};

export const RadioButton: React.FC<IRadioButtonProps> = ({
    name,
    options,
    labels,
    onSelect,
    selectedOption,
    disabled = false,
}) => {
    return (
        <div className='radio-wrapper'>
            {options.map((option, index) => {
                const selectedOp = selectedOption === option;
                return (
                    <RadioButtonOption
                        key={option}
                        parentName={name}
                        option={option}
                        label={labels[index]}
                        onSelect={onSelect}
                        selected={selectedOp}
                        disabled={disabled}
                    />
                );
            })}
        </div>
    );
};
